const ERROR_LOG_SCREENSHOT_PATTERN =
  /^data:image\/(?:jpeg|jpg|png|webp|gif);base64,[A-Za-z0-9+/]+=*$/i;

export function isErrorLogScreenshot(value: unknown): value is string {
  return typeof value === 'string' && ERROR_LOG_SCREENSHOT_PATTERN.test(value);
}
